var map = {
	"./datetime-formats/en": [
		21037,
		40
	],
	"./datetime-formats/en-GB": [
		55557
	],
	"./datetime-formats/en-GB.json": [
		55557
	],
	"./datetime-formats/en.json": [
		21037,
		40
	],
	"./messages/en": [
		54793,
		716
	],
	"./messages/en-GB": [
		86665
	],
	"./messages/en-GB.json": [
		86665
	],
	"./messages/en.json": [
		54793,
		716
	],
	"./number-formats/en": [
		81309,
		732
	],
	"./number-formats/en-GB": [
		45749
	],
	"./number-formats/en-GB.json": [
		45749
	],
	"./number-formats/en.json": [
		81309,
		732
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 31791;
module.exports = webpackAsyncContext;